export default {
    me: () => [200, {
        createdAt: '2020-04-07T11:24:42.000Z',
        email: 'admin@qualitas.com',
        id: 1,
        name: 'Admin User',
        role: 'admin',
        updatedAt: '2020-04-07T11:24:42.000Z',
    }],
}
